import {MutableRefObject, useEffect} from "react"
import wrap from "@utils/wrap"

const useIframeWrapper = (element: MutableRefObject<HTMLElement | undefined>, wrapperClassName = "iframe-wrapper") => {
    useEffect(() => {
        element?.current?.querySelectorAll("iframe")?.forEach((iframe) => {
            const wrapper = document.createElement("div")
            wrapper.className = wrapperClassName
            wrap(iframe, wrapper)
        })
    }, [element])

    return null
}

export default useIframeWrapper
